/**
 * @generated SignedSource<<4f661be91e471be0fd94c0bc6617f338>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditorToolbar_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_data">;
  readonly " $fragmentType": "EditorToolbar_data";
};
export type EditorToolbar_data$key = {
  readonly " $data"?: EditorToolbar_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorToolbar_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorToolbar_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorTranslateButton_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ea9c6f2ce12f5f51a658802dfbe3d925";

export default node;
